import { axios } from 'lib/axios';

export const verifyGoogleAuthSetup = async (data) => {
  return await axios.post('/user/authenticator/verifySetup', data);
};
